"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/styles");
var _material = require("@mui/material");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    input: {
      width: "100%",
      backgroundColor: theme.palette.common.white,
      borderRadius: ".5rem"
    },
    inputDisabled: {
      width: "100%",
      backgroundColor: theme.palette.grey[100],
      borderRadius: ".5rem"
    },
    errorText: {
      marginTop: ".5rem",
      marginLeft: "1rem",
      color: theme.palette.warning.dark,
      fontWeight: "bold"
    },
    dateTime: {
      backgroundColor: theme.palette.common.white,
      borderRadius: ".5rem"
    },
    timePicker: {
      "& MuiOutlinedInput-notchedOutline": {
        borderColor: "red !important"
      }
    }
  };
});
var TimePicker = function TimePicker(_ref, _ref2) {
  var testId = _ref.testId,
    disabled = _ref.disabled,
    value = _ref.value,
    label = _ref.label,
    _onChange = _ref.onChange,
    error = _ref.error,
    errorText = _ref.errorText;
  var rest = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  var classes = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, {
      "data-test-id": testId,
      type: "time",
      label: label,
      value: value,
      disabled: disabled,
      onChange: function onChange(e) {
        _onChange(e.target.value);
      },
      className: classes.dateTime,
      fullWidth: true,
      InputLabelProps: {
        shrink: true
      }
    }), error && errorText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: classes.errorText,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
        variant: "h5",
        children: errorText
      })
    })]
  });
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(TimePicker);